import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'slug'
})
export class SlugPipe implements PipeTransform {

    transform(value: any, ...args: any[]): any {
      if (value && value !== '') {
        const from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;';
        const to = 'aaaaaeeeeeiiiiooooouuuunc------';
        let text = value.toLowerCase();

        for (let i = 0, len = from.length; i < len; i++) {
            text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        const slug = text
            .toString()                     // Cast to string
            .toLowerCase()                  // Convert the string to lowercase letters
            .trim()                         // Remove whitespace from both sides of a string
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/&/g, '-y-')           // Replace & with 'and'
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-');        // Replace multiple - with single -

            /*.toLowerCase()
            .replace(/ /g, '-')
            .replace(/[^\w-]+/g, '');*/

        return slug;
      }
      return value;
    }

}
